<div class="d-flex flex-row justify-content-end">
  <div class="order-label">{{'group_details.search_bar.sort_by' | translate}}</div>
  <div class="order-btn date" [ngClass]="{'active': hasOrderBy('latest')}" (click)="onOrderBy('latest')">{{'discover.search_bar.order_by_date' | translate}}</div>
  <div class="order-btn reach" [ngClass]="{'active': hasOrderBy('reach')}" (click)="onOrderBy('reach')">{{'discover.search_bar.order_by_reach' | translate}}</div>
  <div class="order-btn engagement" [ngClass]="{'active': hasOrderBy('engagement')}" (click)="onOrderBy('engagement')">{{'discover.search_bar.order_by_engagement' | translate}}</div>
  <div class="order-btn impact" [ngClass]="{'active': hasOrderBy('impact')}" (click)="onOrderBy('impact')">{{'discover.search_bar.order_by_impact' | translate}}</div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/discover/order-bar/order-bar.component.html